/** Preferencias de dispositivo elegidas en el lobby pre-unión (antes del join de Zoom). */
let preferences = {
    micId: '',
    cameraId: '',
    joinWithMic: true,
    joinWithCamera: true,
};

export const setPreJoinDevicePreferences = ({
    micId = '',
    cameraId = '',
    joinWithMic = true,
    joinWithCamera = true,
} = {}) => {
    preferences = {
        micId: micId || '',
        cameraId: cameraId || '',
        joinWithMic: joinWithMic !== false,
        joinWithCamera: joinWithCamera !== false,
    };
};

export const getPreJoinDevicePreferences = () => ({ ...preferences });

export const clearPreJoinDevicePreferences = () => {
    preferences = {
        micId: '',
        cameraId: '',
        joinWithMic: true,
        joinWithCamera: true,
    };
};
